const TwitterIcon = ({ width, height }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width || "25"}
      height={height || "24"}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7654 2.21671C21.0997 2.5263 21.1244 3.05334 20.8204 3.39389L14.5029 10.4721L20.9053 20.7193C21.0656 20.9759 21.0759 21.3011 20.9322 21.5677C20.7885 21.8343 20.5136 22 20.215 22H15.3059C15.0262 22 14.7658 21.8544 14.6157 21.6141L10.4741 14.9854L4.4568 21.7272C4.15285 22.0678 3.63539 22.0929 3.30103 21.7833C2.96667 21.4737 2.94202 20.9467 3.24598 20.6061L9.56351 13.5279L3.16112 3.28073C3.0008 3.02413 2.99047 2.69895 3.13417 2.43233C3.27787 2.16571 3.55277 2.00001 3.85139 2.00001H8.76048C9.04022 2.00001 9.30056 2.14557 9.45075 2.38594L13.5923 9.0146L19.6096 2.27279C19.9136 1.93223 20.431 1.90713 20.7654 2.21671ZM5.34185 3.66667L15.7551 20.3333H18.7246L8.31134 3.66667H5.34185Z"
        fill="black"
      />
    </svg>
  )
}

export default TwitterIcon
